import { render, staticRenderFns } from "./BreadcrumbCustom.vue?vue&type=template&id=d4cca91c&scoped=true&"
import script from "./BreadcrumbCustom.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbCustom.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbCustom.vue?vue&type=style&index=0&id=d4cca91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cca91c",
  null
  
)

export default component.exports